A component of the questionnaire to be created.
